import { appConfigStore } from 'Models/AppConfigStore';
import * as React from 'react';
import { BookingDetailSection, SectionProps } from '../../SharedSections/BookingDetailSection';
import { isNullOrUndefined } from 'Util/TypeGuards';
import { getFreightBookingContactDetails } from './FreightBookingHelpers';
import { useIntl } from 'react-intl';

export function FreightReceiverContactDetailSection({ booking, canEdit, onEdit, isInvoiced }: SectionProps) {
	const intl = useIntl();

	if (!booking.bookedSummary) {
		console.error('Booked summary missing, this should not happen');
		return <></>;
	}

	const freightReceiverContact = booking.bookedSummary.freightDetail?.freightReceiverContact;

	if (isNullOrUndefined(freightReceiverContact) || !appConfigStore.freightReceiverDetailsEnabled) {
		return null;
	}

	const lineItems = getFreightBookingContactDetails(freightReceiverContact);
	const sectionContent = (
		<div className="booking-details-section__table">
			<table>
				<tbody>
					{lineItems.map(x => (
						<tr>
							<td className="booking-details-section__table-key">{x[0]}</td>
							<td
								className={`booking-details-section__table-value ${x[0]
									.replace(' ', '-')
									.toLowerCase()}`}
							>
								{x[1]}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);

	return (
		<BookingDetailSection
			sectionName={intl.formatMessage({
				id: 'freight-booking-details__receiver-contact-details-section__label',
				defaultMessage: 'Receiver contact details',
			})}
			sectionContent={sectionContent}
			sectionClassName="contact-details"
			icon={{
				name: 'person',
				useMaterialIcons: true,
			}}
			modificationRules={{
				canEdit: canEdit,
				editType: 'freight-contact-details',
				onEdit: onEdit,
				isInvoiced: isInvoiced,
			}}
		/>
	);
}
